import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3438">
      <Navbar data-id="element-3439" />
      <main data-id="element-3440">
        <ConsularAffairs data-id="element-3441" />
      </main>
      <Footer data-id="element-3442" />
      <FeedbackPopup data-id="element-3443" />
    </div>;
}